// src/components/dashboard/RecommendedCard.jsx

import React from 'react';

const RecommendedCard = ({ title, description, meta, tag, isDarkMode, onClick }) => {
  const handleClick = () => {
    if (onClick && typeof onClick === 'function') {
      onClick();
    }
  };

  return (
    <div 
      className={`rounded-xl border overflow-hidden shadow-sm transition-all duration-200 hover:-translate-y-1 hover:shadow-md h-full cursor-pointer group ${
        isDarkMode 
          ? 'bg-[#1F2023] border-[#41425A] shadow-black shadow-opacity-30 hover:border-purple-500' 
          : 'bg-white border-[#DBDCED] shadow-gray-900 shadow-opacity-10 hover:border-purple-400'
      }`}
      onClick={handleClick}
    >
      {/* Header with gradient */}
      <div className={`px-4 py-3 text-white text-lg font-semibold relative overflow-hidden ${
        isDarkMode ? 'bg-gradient-to-r from-[#7376B8] to-[#5a5b75]' : 'bg-gradient-to-r from-gray-800 to-gray-900'
      }`}>
        {/* Background pattern */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent transform -skew-x-12"></div>
        <span className="relative z-10">{title}</span>
      </div>

      {/* Content */}
      <div className="p-4 space-y-3">
        <p className={`text-sm leading-relaxed ${
          isDarkMode ? 'text-gray-300' : 'text-gray-600'
        }`}>
          {description}
        </p>
        
        {/* Tags and Meta Row */}
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            {tag && (
              <span className={`inline-block px-2.5 py-1 rounded-full text-xs font-medium ${
                tag === 'NEW' 
                  ? (isDarkMode ? 'bg-green-900/50 text-green-300 border border-green-700' : 'bg-green-100 text-green-700 border border-green-200')
                  : tag === 'POPULAR'
                  ? (isDarkMode ? 'bg-orange-900/50 text-orange-300 border border-orange-700' : 'bg-orange-100 text-orange-700 border border-orange-200')
                  : (isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-100 text-gray-600')
              }`}>
                {tag}
              </span>
            )}
          </div>
          
          {/* Action Arrow */}
          <div className={`w-8 h-8 rounded-full flex items-center justify-center transition-all duration-200 group-hover:scale-110 ${
            isDarkMode 
              ? 'bg-purple-600/20 text-purple-400 group-hover:bg-purple-600 group-hover:text-white' 
              : 'bg-purple-100 text-purple-600 group-hover:bg-purple-600 group-hover:text-white'
          }`}>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </div>

        {/* Meta information */}
        {meta && (
          <div className={`text-xs pt-2 border-t ${
            isDarkMode ? 'text-gray-400 border-gray-700' : 'text-gray-500 border-gray-200'
          }`}>
            <div className="flex items-center space-x-1">
              <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span>{meta}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecommendedCard;